<template lang="html">
  <SceneContent v-bind="$props" />
</template>

<script>
  import SceneContent from '@/components/interview/videointerview/SceneContent.vue'

  export default {
    name: 'process-interview-videointerview-scene',

    components: {
      SceneContent
    },

    props: {
      interview: Object
    }
  }
</script>

<style>
</style>
